export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13603.fb201931.jpg";